class IndustriesMenu {
  constructor() {
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setInitialState();
  }

  setupEventListeners() {
    // Find all industries menu items
    const menuItems = document.querySelectorAll('.industries-menu-item');
    
    menuItems.forEach(item => {
      item.addEventListener('mouseenter', (e) => {
        this.handleMenuHover(e.target);
      });

      item.addEventListener('click', (e) => {
        e.preventDefault();
        const url = e.target.getAttribute('data-banner-url');
        if (url) {
          window.location.href = url;
        }
      });
    });
  }

  handleMenuHover(menuItem) {
    const industry = menuItem.getAttribute('data-industry');
    
    // Remove active class from all menu items
    document.querySelectorAll('.industries-menu-item').forEach(item => {
      item.classList.remove('active');
    });

    // Add active class to hovered item
    menuItem.classList.add('active');

    // Hide all banner items
    document.querySelectorAll('.industries-banner-item').forEach(item => {
      item.classList.remove('active');
    });

    // Show corresponding banner item
    const bannerItem = document.querySelector(`.industries-banner-item[data-industry="${industry}"]`);
    if (bannerItem) {
      bannerItem.classList.add('active');
    }
  }

  setInitialState() {
    // Set the first menu item as active by default
    const firstMenuItem = document.querySelector('.industries-menu-item');
    const firstBannerItem = document.querySelector('.industries-banner-item');
    
    if (firstMenuItem && firstBannerItem) {
      firstMenuItem.classList.add('active');
      firstBannerItem.classList.add('active');
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new IndustriesMenu();
});

// Also initialize if script is loaded after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new IndustriesMenu();
  });
} else {
  new IndustriesMenu();
}
